import React from 'react';

const Empty = () => {
  return (
    <div className="canvas--empty text-center p-4">
      <h5>Start building your form!</h5>
      <p>Drag field types from the left panel and drop here to being your form.</p>
    </div>
  )
};

export default Empty;